const filesize = {
    methods: {
        getItemFilesize(item) {
            let size = 0;
            if (this.item && !this.item.isMediaSet) {
                if (item.hasOriginalSize) {
                    size = item.original.size;
                } else if (item.hasSize) {
                    size = item.file.size;
                }
            } else {
                size = item.mediaTotalFilesize;
            }
            return size;
        },
    },
};

export default filesize;
